var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tg-button',{class:_vm.classes,attrs:{"round":"","disabled":_vm.num == 0}},[_vm._v(_vm._s(_vm.$t('component.btn.trial', {num: _vm.num})))])
}
var staticRenderFns = []

export { render, staticRenderFns }